import { LitElement, css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('ep-timeline-divider')
export class EPTimelineDivider extends LitElement {

  render() {
    return html``
  }
  
  // protected override createRenderRoot(): Element | ShadowRoot {
  //   return this;
  // }

  static styles = css`
    :host {
      display: block;
      margin: 0;
      border: 0;
      border-top: 2px solid var(--border-muted);
      /* margin-bottom: 10px; */
      --text-default: rgb(31, 35, 40);
      --text-muted: rgb(101, 109, 118);
      --border-muted: rgb(216, 222, 228);
      --border-default: rgb(208, 215, 222);
      --badge-background: rgb(234, 238, 242);
      --canvas-subtle: rgb(246, 248, 250);
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-timeline-divider': EPTimelineDivider
  }
}
